var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitlabGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 67,
    viewBox: "0 0 201 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.2 66.5L113.5 25.6H86.9L100.2 66.5Z",
    fill: "#7B878D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 66.5L86.9 25.6H68.3L100.2 66.5Z",
    fill: "#BDC5D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3 25.6L64.3 38C63.9 39.1 64.4 40.3 65.3 41.1L100.2 66.5L68.3 25.6Z",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3 25.6H86.9L78.9 0.899988C78.5 -0.400012 76.7 -0.400012 76.3 0.899988L68.3 25.6Z",
    fill: "#7B878D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 66.5L113.5 25.6H132.1L100.2 66.5Z",
    fill: "#BDC5D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1 25.6L136.1 38C136.5 39.1 136 40.3 135.1 41.1L100.2 66.5L132.1 25.6Z",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1 25.6H113.5L121.5 0.899988C121.9 -0.400012 123.7 -0.400012 124.1 0.899988L132.1 25.6Z",
    fill: "#7B878D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.4,
    height: 66.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabGray);
export default __webpack_public_path__ + "static/media/gitlab-gray.0e5a9c52dd69a64f99aead798255b2a8.svg";
export { ForwardRef as ReactComponent };